import { Button } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";

const LanguageToggleButton = ({ onLocaleChange }) => {
  const { i18n } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    let savedLanguage = localStorage.getItem("language");

    if (!savedLanguage) {
      savedLanguage = "en";
      localStorage.setItem("language", savedLanguage);
    }

    i18n.changeLanguage(savedLanguage);
    document.dir = savedLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = savedLanguage;
  }, [i18n]);

  const toggleLanguage = () => {
    const newLanguage = i18n.language === "ar" ? "en" : "ar";
    localStorage.setItem("language", newLanguage);

    if (onLocaleChange) {
      onLocaleChange(newLanguage);
    }
    window.location.href = window.location.href.replace(
      `/${i18n.language}/`,
      `/${newLanguage}/`
    );
  };

  return (
    <Button
      onClick={toggleLanguage}
      sx={{
        border: "1px solid #0A1F52",
        borderRadius: "50%",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "500",
        fontSize: "18px",
        color: theme.palette.primary.label,
        width: {
          xs: "40px",
          sm: "48px",
          md: "52px",
        },
        height: {
          xs: "40px",
          sm: "48px",
          md: "52px",
        },
        minWidth: {
          xs: "40px",
          sm: "48px",
          md: "52px",
        },
      }}
    >
      {i18n.language === "en" ? "AR" : "EN"}
    </Button>
  );
};

export default LanguageToggleButton;
